import { Modal } from "./modal";
import { Carousel } from "../carousel";

// *************************************************************************
// Třída s modální galerií.
//
// ModalGallery není předána do veřejného namespace (není to zatím potřeba).
// ModalGallery používá Carousel, čímž se vyřešila celá funkční stránka věci. Úkolem
// této třídy je tak pouze spojit dohromady funkcionalitu modálního okna a carouselu.
// Modální dialog proto rozšíříme o markup pro carousel, do kterého přidáme obrázky.
// A to je celé... všechno ostatní (veškerou funkcionalitu) už pak zajistí hotové
// třídy Modal a Carousel.
// *************************************************************************

//
// Třída ModalGallery dědí od třídy Modal.
//
export function ModalGallery(element) {
	Modal.call(this, element);
	this.gallery = this.element.querySelector(".modal-gallery-inner");
	this.carousel = new Carousel(this.gallery);

	this.gallery.addEventListener("carouselslidebefore", this.onBeforeSlide.bind(this));
	this.gallery.addEventListener("carouselslide", this.onAfterSlide.bind(this));

	this.enableClipboard = false;
}
ModalGallery.prototype = Object.create(Modal.prototype);
ModalGallery.prototype.constructor = ModalGallery;

ModalGallery.prototype.onBeforeSlide = function(event) {
	var clipboardButton = this.gallery.querySelector(".modal-btn[data-clipboard]");
	if (clipboardButton) {
		clipboardButton.remove();
	}
}

ModalGallery.prototype.onAfterSlide = function(event) {
	if (this.enableClipboard) {
		var url = event.detail.item.slide.getAttribute("src");
		this.gallery.querySelector(".modal-gallery-content").innerHTML += "<div class='modal-btn modal-bottom-right' data-clipboard='" + url + "'><span class='modal-icon modal-icon-copy'></span></div>";
	}
}


//
// Vytvoří modální dialog s kostrou galerie.
//
ModalGallery.create = function(links) {
	var modal = Modal.create();
	modal.classList.add("modal-gallery");

	var hasDots = 1 < links.length;

	// Obyčejný modální dialog obohatíme o markup galerie (její kostry).
	modal.innerHTML = "<div class='modal-gallery-inner'>" +
		"<div class='modal-gallery-content " + (hasDots ? "has-navigation" : "") + "'>" +
		"<div class='modal-gallery-slides' data-carousel='slides'></div>" +
		(hasDots ? "<div class='modal-gallery-btn modal-btn modal-center-left' data-carousel='prev'><span class='modal-icon modal-icon-arrow-left'></span></div>" : "") +
		(hasDots ? "<div class='modal-gallery-btn modal-btn modal-center-right' data-carousel='next'><span class='modal-icon modal-icon-arrow-right'></span></div>" : "") +
		"</div>" +
		(hasDots ? "<div class='modal-gallery-nav' data-carousel='dots'></div>" : "") +
		"<div class='modal-gallery-btn modal-btn modal-top-right' data-modal='close'><span class='modal-icon modal-icon-cross'></span></div>" +
		"</div>";

	// Přidáme obrázky (nebo videa).
	var slides = modal.querySelector("[data-carousel='slides']");
	var dots = modal.querySelector("[data-carousel='dots']");

	for (var i = 0; i < links.length; ++i) {
		var link = links[i];
		var url = link.getAttribute("href") || link.getAttribute("data-href");
		var caption = link.getAttribute("data-caption");
		var isAutoplay = link.getAttribute("data-gallery-autoplay") == "true";

		// Slide
		let slide = document.createElement("div");
		slide.classList.add("modal-gallery-slide");

		if (url.match(/.*\.mp4$/i)) {
			// Video
			var video = document.createElement("video");
			video.setAttribute("src", url);
			video.setAttribute("controls", "controls");
			if (isAutoplay) {
				video.setAttribute("autoplay", "autoplay");
			}

			slide.appendChild(video);

			// TODO:
			// if (dots) { ... }
		}
		else if (url.match(/^http(s)?:\/\/(www\.)?youtube\.com\//i) || url.match(/^http(s)?:\/\/(www\.)?youtu\.be\//i)) {
			let urlParts = new URL(url);
			let videoId = urlParts.searchParams.get("v") || urlParts.pathname.replace(/^\//, "");

			let iframe = document.createElement("iframe");
			iframe.setAttribute("width", 1920);
			iframe.setAttribute("height", 1080);
			iframe.setAttribute("src", "https://www.youtube-nocookie.com/embed/" + videoId + (isAutoplay ? "?autoplay=1" : ""));
			iframe.setAttribute("frameborder", "0");
			iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
			iframe.setAttribute("allowfullscreen", "allowfullscreen");

			slide.appendChild(iframe);
		}
		else {
			// Obrázek
			slide.classList.add("modal-sending-request");
			var image = document.createElement("img");
			image.onload = function() {
				slide.classList.remove("modal-sending-request");
			}
			image.src = url;

			slide.appendChild(image);

			if (dots) {
				var dot = document.createElement("img");
				dot.setAttribute("src", url);
				dots.appendChild(dot);
			}

			// Popisek obrázku
			if (caption) {
				let element = document.createElement("div");
				element.classList.add("modal-gallery-caption");
				element.innerHTML = caption;
				slide.appendChild(element);
			}
		}

		slides.appendChild(slide);
	}

	return modal;
}


//
// Vytvoří nebo vrátí existující instanci modálního dialogu.
//
ModalGallery.get = function(element, links) {
	return Modal.get(element, ModalGallery, ModalGallery.create.bind(null, links));
}


//
// Vytvoří galerii po kliknutí na element.
//
ModalGallery.createFromElement = function(element) {
	var galleryId = element.getAttribute("data-gallery");
	var links = document.querySelectorAll("[data-gallery='" + galleryId + "']");
	var enableClipboard = element.getAttribute("data-gallery-clipboard") == "true";

	var gallery = ModalGallery.get(null, links);
	gallery.enableClipboard = enableClipboard;

	// Galerie je vytvořená ze všech prvků na stránce se stejným galleryId, což nutně nemusí být
	// první prvek z galerie. Pro intuitivnost proto chceme, aby se galerie zobrazila přímo na tom
	// slide, na který uživatel klikl. Najděme ho v kolekci a přesuňme se na něj.
	var galleryElements = Array.from(links);
	gallery.carousel.move(galleryElements.indexOf(element));

	// Galerie je vytvořená, zobrazme ji.
	gallery.open();
}


// *************************************************************************
// Události.
// *************************************************************************

//
// Galerie se spouští kliknutím na tlačítko.
//
document.addEventSelectorListener("click", "[data-gallery]", function(event, target) {
	event.preventDefault();
	ModalGallery.createFromElement(target);
});


//
// Uzavření modálního okna kliknutím na černé pozadí.
//
document.addEventMatchesListener("click", ".modal-gallery-content, .modal-gallery-nav, .modal-gallery-slide", function(event, target) {
	event.preventDefault();
	ModalGallery.get(target).close();
});


//
// Galerii lze ovládat klávesnicí.
//
document.addEventListener("keydown", function(event) {
	if (event.key != "ArrowLeft" && event.key != "ArrowRight") {
		return;
	}

	var modal = document.querySelector(".modal .modal-gallery-inner");
	if (!modal) {
		return;
	}

	event.preventDefault();

	if (event.key == "ArrowLeft") {
		ModalGallery.get(modal).carousel.prev();
	}
	else {
		ModalGallery.get(modal).carousel.next();
	}
});

// Odstranění titulku
document.addEventSelectorListener("click", ".modal-gallery-caption", function(event, target) {
	event.preventDefault();
	target.remove();
});
